<script lang="ts">
export default {
  name: 'EmptyLayout',
}
</script>

<template>
  <NuxtLayout class="nc-h-screen">
    <slot></slot>
  </NuxtLayout>
</template>
